import Vue from 'vue'
import Vuex from 'vuex'
import System from './modules/system'
import Sell from './modules/sell'
import { deepClone } from '@/util'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    https: 'http://erp.jieheyun.cn/',
    ticketState: [],
    tabsList: [
      {
        children: '',
        flag: true,
        id: 8,
        powerCode: 'url:user:canlendar',
        powerFather: 22,
        powerIcon: 'el-icon-date',
        powerName: '首页',
        powerType: 1,
        powerUrl: '/workbench/workbenchManage/home',
        serial: 1
      }
    ],
    backlogActiveName: 'a',
    currentMenu: null, // 当前菜单
    informNum: {},
    isFalse: false,
    quickareaData: [],
    dataSubMenuEx: [], // 侧边栏数据
    generateContactList: [], // 备货清单列表
    dataSubMeunCurActiveEx: '', // 当前跳转详情url父路径
    financeTableHeight: window.innerHeight - 380, // 财务表格高度
    productGuidIn: '5fcee462cb602a0886edd3e5', // 产品-批量导入
    productGuidBrand: '5fcee477cb602a0886edd3e6', // 产品-品牌系数导出导入
    productGuidSerice: '5fcee486cb602a0886edd3e7', // 产品-系列系数导出导入
    productGuidPro: '5fcee493cb602a0886edd3e8', // 产品-型号系数导出导入
    sellGuidIn: '5fcee4e0cb602a0886edd3eb', // 销售-询价导入表格
    sellGuidInExcel: '5ff94378cb60b51dd0202d45', // 销售询价-产品导出【excel】
    sellDeliverSerial: '5ffab6e8cb602f6d8c3b0f0b', // 销售发货-通用-导入产品序列号
    clientGuidIn: '5fcee4c9cb602a0886edd3ea', // 客户-批量导入
    purchasePlanGuidIn: '609a1625a602de8d7bd3c3a4', // 采购-采购清单采购区导入产品
    purchaseGuidIn: '5fcee41ecb602a0886edd3e3', // 采购-待处理反馈询价导出导入
    storgeGuidIn: '5fcee448cb602a0886edd3e4 ', // 仓储-货架管理批量新增
    quoteCuidIn: '5fcee4aecb602a0886edd3e9', // 供应商-报价单模版
    financialAffairsCuidIn: '5fdc5889cb60a506b247f982', // '5fcee4aecb602a0886edd3e9', // 财务-银行收款导入
    openingInventoryGuid: '5fcf55a7cb60f3ed62e9d789', // 仓库-期初库存批量导入
    inventoryListGuid: '5fe1d1c9cb60872a424773cd', // 仓储-入库清单导出-物流配送
    expressInventoryListGuid: '5fe1d1d4cb60872a424773ce', // 仓储-入库清单导出-快递配送
    supplierInventoryListGuid: '5fe1d1dbcb60872a424773cf', // 仓储-入库清单导出-供应商配送
    optionsListGuidwarse: '5fe40c5ecb60c2d8654ab333', // 仓储-备货清单导出-仓储备货
    optionsListGuid: '5fe40c9acb607cbf09caabe3', // 仓储-备货清单导出-调拨备货.
    shipmentsListself: '5fe445e5cb60c0a1b2e890bc', // 仓储-发货清单导出-客户自提
    shipmentsListLogistics: '5fe445d0cb60c0a1b2e890ba', // 仓储-发货清单导出-物流配送
    shipmentsListExpressage: '5fe445ddcb60c0a1b2e890bb', // 仓储-发货清单导出-快递配送
    shipmentsListStorge: '5fe445efcb60c0a1b2e890bd', // 仓储-发货清单导出-仓库配送
    realTimeDataListstorge: '5fe45ba9cb60ef463df0807b', // 仓储-实时库存导出产品
    realTimeDataList: '5fe45bb3cb60ef463df0807c', // 仓储-实时库存导出—仓库查询
    storeManagementList: '5fe55c27cb60432f39d6c0b3', // 仓储-仓内调拨导出
    storeManagementcheckList: '5fe94a60cb606819c294fb79', // 仓储-仓库盘点单导出通用模板
    addProfitLossCoeDeriveList: '5fe9572ecb606819c294fb81', // 仓储产品盈亏记录导出
    addInOutProductDetailList: '5fe97edacb608efc411daeb9', // 产品历史出入库导出产品序列号/单据历史出入库导出产品序列号
    addProductSerialCodeList: '5fe99036cb608efc411daed2', // 仓储-历史出入库查询单据导出 - 产品查询.
    addProductSerialCodeListIn: '5fe99d43cb602edc665143e1', // 仓储-历史出入库查询单据导出 -仓内调拨单
    addProductSerialCodeListPursure: '5fe99d5dcb602edc665143e4', // 仓储-历史出入库查询单据导出-采购入库单
    addProductSerialCodeListAllot: '5fe99d66cb602edc665143e5', // 仓储-历史出入库查询单据导出-调拨出库单
    addProductSerialCodeListAllotIn: '5fe99d6fcb602edc665143e6', // 仓储-历史出入库查询单据导出-调拨入库单
    addProductSerialCodeListAllotOut: '5fe99d77cb602edc665143e7', // 仓储-历史出入库查询单据导出-销售出库单
    maintainAddProductListAllotIn: '5fe99d54cb602edc665143e3', // 仓储-历史出入库查询单据导出 -维修入库单-供应商
    maintainAddProductListAllotOut: '5fe99d4ccb602edc665143e2', // 仓储-历史出入库查询单据导出 -维修出库单-客户
    maintainAddProductListCuName: '5fe99d34cb602edc665143e0', // 仓储-历史出入库查询单据导出 - 维修入库单-客户
    maintainAddProductListSuName: '5fe99d2acb602edc665143df', // 仓储-历史出入库查询单据导出 - 维修出库单-供应商
    returnTreasury: '5fe99d20cb602edc665143dd', // 仓储-历史出入库查询单据导出 - 退货入库单
    returnTreasuryOut: '5fe99bfecb602edc665143dc', // 仓储-历史出入库查询单据导出 - 退货出库单
    financePendingPaymentApplicationBankTransfer: '5ff4420bcb6039c8910ada23', // 财务-待处理付款申请-银行转账
    FfnancePendingPaymentApplicationAcceptanceDraft: '5ff441fecb6039c8910ada22', // 财务-待处理付款申请-承兑汇票
    financePendingBillingApplication: '5ff563edcb603b2afd6ac6a6',
    financeExportReceiptApplication: '5ff6a8accb60ee81fc0a9b51',
    cusBalanceUrl: '5ff671f5cb60e243427a460b', // 财务-客户余额收支记录
    arrearsCustomersUrl: '60dbd42c67e4136d4b54f479', // 财务模块-欠款客户导出
    supplierBalanceUrl: '5ff671ddcb60e243427a4609', // 财务-供应商余额-账户余额收支记录
    supplierDeductionUrl: '5ff671e9cb60e243427a460a', // 财务-供应商余额-抵扣金额收支记录
    financeRefundTicketUrl: '5ff6b145cb609c026546b9c9', // 财务-我的待处理退票导出
    financeCreditUrl: '5ff68697cb60e243427a460f', // 财务-红字发票申请导出
    purchasePlanListUrl: '609a1625a602de8d7bd3c3a4', // 采购清单-待审核列表导出清单
    financeLogisticCoeDerive: '5ff7c234cb6016887f8477eb', // 财务-物流快递费用结算导入导出
    productInformationGuid: '609e2ca767e4031786e617f2' // 生成合同（采购生成）-导入产品
  },
  mutations: {
    selectMenu (state, val) {
      // console.log(val)
      // 如果点击应该是首页的话 要把这份数据清空 因为头部组件已经把首页写死了 只有点击不是首页菜单才存储当前菜单
      if (val.powerName === 'home') {
        state.currentMenu = null
      } else {
        state.currentMenu = val
        // 如果等于-1说明tabsList不存在那么插入，否则什么都不做
        const result = state.tabsList.findIndex(item => item.powerName === val.powerName)
        if (result === -1) {
          state.tabsList.push(val)
        }
        // result === -1 ? state.tabsList.push(val) : ''
      }
    },
    // 关闭标签
    closeTab (state, val) {
      const result = state.tabsList.findIndex(item => item.powerName === val.powerName)
      state.tabsList.splice(result, 1)
    },
    updataInfofrom (store, data) {
      store.informNum = deepClone(data)
    },
    updataQuickAreaData (store, data = []) {
      store.quickareaData = data
    },
    setDataSubMeunEx (store, data = []) {
      store.dataSubMenuEx = data
    },
    setDataSubMeunCurActiveEx (store, data = '') {
      store.dataSubMeunCurActiveEx = data
    },
    setBacklogActiveName (store, data = 'a') {
      store.backlogActiveName = data
    }
  },
  actions: {},
  modules: {
    System,
    Sell
  }
})
